import { GraphQLTypes, InputType, Selector, $ } from '@zeus/index';
import { typedGql } from '@zeus/typedDocumentNode';
import { scalars } from '~/gql/utils/scalars';

const friendSelector = Selector('Friend')({
    avatar : {
        fileName: true
    },
    username : true,
    id: true,
    wonBattles: true,
    isFriend: true,
    createdAt: true,
})

const userFriendSelector = Selector('User')({
    id : true,
    username : true
})


export const GQL_FRIEND_LIST = typedGql('query', { scalars })({
  getFriendsList: {
    ...friendSelector
  },
});


export const GQL_ADD_TO_FRIEND_LIST = typedGql('mutation')({
    addToFriendsList: [
    {
      friendId: $('friendId', 'String!'),
    },
    userFriendSelector,
  ],
});

export const GQL_REMOBE_FROM_FRIEND_LIST = typedGql('mutation')({
    removeFromFriendsList: [
    {
      friendId: $('friendId', 'String!'),
    },
    userFriendSelector,
  ],
});

export type StoredFriends = InputType<
  GraphQLTypes['Friend'],
  typeof friendSelector
>;

